import React, { useEffect, useRef, useState } from "react";
import Loader from "../../../../components/loader/loader";

import Snackbar from "../../../../components/snackbar/snackbar";
import {
  user_company_domain_list,
  user_get_pplication,
  user_update_request,
} from "../../user.api";
import {
  builtup,
  euip,
  jointVenture,
  landon,
  ownland,
} from "./components/areadata";
import AreaDetails from "./components/areaDetails";
import BasicDetails from "./components/basicDetails";
import View from "./components/viewDetails";
import "./style.css";
import { useParams } from "react-router-dom/cjs/react-router-dom";
export default function UpdateCompanyRequest(props) {
  const [activeStep, setActiveStep] = useState(0);
  const [defaultkey, setdefaultkey] = useState("");
  const [basicData, setBasicData] = useState({});
  const [areaData, setAreaData] = useState({});
  const [domainData, setDomain] = useState([]);
  const [addCount, setCount] = useState(1);
  const [data, setData] = useState({});
  const myRef = useRef(null);
  const premise = useParams().id;
  const [openView, setOpenView] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [areamange, setareaManage] = useState({});
  const [fileChanged, setFileChanged] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [keyValue, setKeyValue] = useState(0);

  // const getDomainTypes = (basedata) => {
  //   user_company_domain_list().then((res) => {
  //     let data = res.data;
  //     if (res.data?.length !== 0) {
  //       basedata?.domain_types?.forEach((item) => {
  //         data?.forEach((items) => {
  //           if (items.id === item.domain_type_id) {
  //             items["checked"] = true;
  //             // setBasicData({ ...basedata, any_other_flag: false });
  //           }
  //         });
  //       });

  //       setDomain(data);
  //     }
  //   });
  // };
  const getDomainTypes = () => {
    setIsActive(true);
    user_company_domain_list().then((res) => {
      let domData = res?.data;
      getApplication(domData);
    });
  };
  const handleDomain = () => {
    if (basicData?.domain_types) {
      setCount(addCount + 1);
    }
  };
  const action = (id, data, key) => {

    myRef.current.scrollIntoView();
    if (id === 0) {
      let dom = [];
      domainData.forEach((item) => {
        if (item.checked)
          dom.push({ domain_name: item.domain_name, id: item.id });
      });
      setActiveStep(1);
      setBasicData({ ...basicData, ...data, domain_types: dom });
      //
    } else if (id === 2) {
      // Validation is handled in areaDetails.js handlepreview function
      // Just proceed to preview
      setActiveStep(2);
      setdefaultkey(key);
      setareaManage(data);
      setBasicData({ ...basicData, ...data });
    } else if (id === 1) {
      setActiveStep(0);
    } else if (id === 3) {
      setareaManage({
        area_type: basicData.area_type,
        area_management: basicData.area_management,
      });
      setActiveStep(1);
    } else if (id === 4) {
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    // Validate area requirements
    if (!basicData.area_type) {
      setSnackMessage("Please select area type");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }

    if (!basicData.area_management || basicData.area_management.length === 0) {
      setSnackMessage("Please add area requirements");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }

    // Check if at least one area has location selected
    const hasValidArea = basicData.area_management.some(item => item.location_id);
    if (!hasValidArea) {
      setSnackMessage("Please select location for at least one area requirement");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }

    const form = new FormData();
    let areatype = [];
    if (basicData.area_management) {
      basicData?.area_management?.forEach((item, index) => {
        if (item.location_id) {
          areatype[index] = item;
        }
      });
    }
    form.append("company_name", basicData.company_name ?? null);
    form.append("person_name", basicData.person_name ?? null);
    form.append("person_designation", basicData.person_designation ?? null);
    form.append("address", basicData.address ?? null);
    form.append("email", basicData.email ?? null);
    form.append("alternate_email", basicData.alternate_email ?? "");
    form.append("domain_types", JSON.stringify(basicData.domain_types) ?? null);
    form.append(
      "abstract_project_proposal",
      basicData.abstract_project_proposal ?? null
    );
    form.append(
      "upload_proposal",
      fileChanged ? basicData.upload_proposal ?? "" : ""
    );
    form.append("capital_investment", basicData.capital_investment ?? null);
    form.append("ex_man_power", basicData.ex_man_power ?? null);
    form.append(
      "product_profiles",
      JSON.stringify(basicData.product_profiles) ?? null
    );
    form.append("area_type", basicData.area_type ?? null);
    form.append("site_link", basicData.site_link ?? "")
    form.append(
      "country_code",
      basicData.alternate_phone ? basicData.country_code : ""
    );
    form.append("alternate_phone", basicData.alternate_phone ?? "");
    basicData.area_management.forEach((item, index) => {
      if (item.category) {
        form.append(`area_management[${index}][category]`, item.category);
      }
      if (item.location_id) {
        form.append(`area_management[${index}][location_id]`, item.location_id);
      }
      if (item.location) {
        form.append(`area_management[${index}][location]`, item.location);
      }
      if (item.sub_location) {
        form.append(`area_management[${index}][sub_location]`, item.sub_location);
      }
      if (item.built_space_type) {
        form.append(`area_management[${index}][built_space_type]`, item.built_space_type);
      } else if (item.built_space_type_name) {
        form.append(`area_management[${index}][built_space_type]`, item.built_space_type_name);
      }
      if (item.land_address) {
        form.append(`area_management[${index}][land_address]`, item.land_address);
      }
      if (item.area_in_sqft) {
        form.append(`area_management[${index}][area_in_sqft]`, item.area_in_sqft);
      }
      if (item.area_in_acres) {
        form.append(`area_management[${index}][area_in_acres]`, item.area_in_acres);
      }
      if (item.survey_no) {
        form.append(`area_management[${index}][survey_no]`, item.survey_no);
      }
      if (item.block_no) {
        form.append(`area_management[${index}][block_no]`, item.block_no);
      }
      if (item.village_name) {
        form.append(`area_management[${index}][village_name]`, item.village_name);
      }
      if (item.nature_of_holding) {
        form.append(`area_management[${index}][nature_of_holding]`, item.nature_of_holding);
      }
      if (item.interest) {
        form.append(`area_management[${index}][interest]`, item.interest);
      }
      if (item.proposal_file) {
        form.append(`area_management[${index}][proposal_file]`, item.proposal_file);
      }
      if (item.management_plan) {
        form.append(`area_management[${index}][management_plan]`, item.management_plan);
      }
      if (item.investment_model) {
        form.append(`area_management[${index}][investment_model]`, item.investment_model);
      }
      if (item.lease_year) {
        form.append(`area_management[${index}][lease_year]`, item.lease_year);
      }
      if (item.area_management_id) {
        form.append(`area_management[${index}][area_management_id]`, item.area_management_id);
      }
    });
    form.append("any_other_flag", basicData.any_other_flag == true ? "1" : "0");
    form.append(
      "any_other_domain",
      basicData.any_other_flag == true ? basicData.any_other_domain : ""
    );
    form.append("file_name", basicData.file_name ?? "");
    if (basicData.id) form.append("application_id", basicData.id);
    setIsActive(true);
    user_update_request(form)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        console.log(form);
        setIsActive(false);
      })
      .catch((error) => {
        // console.log(error)
        setSnackMessage(error.response.data.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  const navLabel = [
    { id: 0, activeStep: 0, name: "Basic Information" },
    { id: 1, activeStep: 1, name: "Area Requirements" },
  ];

  const headlperText = {
    header: "* Indicates mandatory fields",
  };
  const handleChangedata = (id, name) => {
    setdefaultkey(id);

    if (name === basicData?.area_type) {
      getUpdate();
    } else if (name === "built_up_space") {
      setareaManage(builtup);
    } else if (name === "equipped_facility") {
      setareaManage(euip);
    } else if (name === "land_on") {
      setareaManage(landon);
    } else if (name === "joint_venture") {
      setareaManage(jointVenture);
    } else if (name === "own_land") {
      setareaManage(ownland);
    }
    setCount(addCount + 1);
  };
  const getUpdate = () => {
    setareaManage({
      area_type: basicData?.area_type,
      area_management: basicData?.area_management,
    });
  };

  const getApplication = (domData) => {
    setIsActive(true);
    user_get_pplication().then((res) => {
      // res is the response body returned by the API wrapper (res.data in axios)
      // res.data is the nested application object
      const appData = res?.data;

      if (appData) {
        setData(appData);
        // Map checked status for domains from appData
        domData?.forEach((item) => {
          item["checked"] = appData.domain_types?.some(
            (dom) => item?.domain_name === dom?.domain_name
          );
        });
        setDomain(domData);

        let d = {
          ...appData,
          any_other_flag:
            appData.any_other_flag && appData.any_other_flag !== "0"
              ? true
              : false,
          any_other_domain:
            appData.any_other_domain && appData.any_other_flag !== "0"
              ? appData.any_other_domain
              : "",
          country_code:
            appData.country_code === "null" || appData.country_code === "undefined"
              ? ""
              : appData.country_code,
        };
        setBasicData(d);

        setareaManage({
          area_type: appData.area_type,
          area_management: appData.area_management,
        });

        // Set default active key for accordion based on area_type
        let ak = "";
        if (appData.area_type === "built_up_space") ak = "0";
        else if (appData.area_type === "equipped_facility") ak = "0";
        else if (appData.area_type === "land_on") ak = "2";
        else if (appData.area_type === "joint_venture") ak = "3";
        else if (appData.area_type === "own_land") ak = "4";
        setdefaultkey(ak);

        setKeyValue(1);
      }
      setIsActive(false);
    });
    setCount(addCount + 1);
  };
  useEffect(() => {
    getDomainTypes();
  }, []);
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.history.push("/dashboard");
    }
  };
  const handleFile = () => {
    setFileChanged(true);
  };
  console.log(basicData);

  return (
    <div className="page-bg" ref={myRef}>
      <Loader open={isActive} />
      <div>
        <div className="dash-banner ">
          <div className="tit-txt">{data?.area_type == "own_land" ? "Update Application for a New Company in KSPACE Own Premises" : "Update Application for a New Company in KSPACE Premises"}</div>
        </div>
      </div>
      <div className="formbg form-bg">
        <div className="container form-section">
          <div className="mb-3 d-flex justify-content-start">
            <button
              type="button"
              className="btn btn-light border"
              style={{
                borderRadius: "6px",
                padding: "8px 20px",
                fontWeight: "bold",
                fontSize: "14px",
                display: "inline-flex",
                alignItems: "center",
                gap: "8px"
              }}
              onClick={() => props.history.push("/dashboard")}
            >
              <i className="fa fa-arrow-left"></i> Back to Dashboard
            </button>
          </div>
          <div className="">
            {activeStep < 2 && (
              <>
                <div className="header-helper-text">{headlperText.header}</div>
                <div className="d-flex">
                  {navLabel.map((item, index) => (
                    <div
                      className={
                        index % 2 === 1
                          ? item.activeStep === activeStep
                            ? "headerbuttoneven active"
                            : "headerbuttoneven"
                          : item.activeStep === activeStep
                            ? "headerbuttonodd active"
                            : "headerbuttonodd"
                      }
                    >
                      <div
                        className={
                          index % 2 === 1 ? "indexCont even" : "indexCont "
                        }
                      >
                        {index + 1}
                      </div>
                      <div> {item.name}</div>
                    </div>
                  ))}
                </div>
              </>
            )}
            <div className="fomy form-inner-section">
              {activeStep === 0 && (
                <BasicDetails
                  {...props}
                  data={basicData}
                  action={action}
                  edit={true}
                  key={keyValue}
                  formData={basicData}
                  setDomain={setDomain}
                  update={true}
                  handlefile={handleFile}
                  domainData={domainData}
                />
              )}
              {activeStep === 1 && (
                <AreaDetails
                  {...props}
                  key={addCount}
                  data={basicData?.area_management}
                  update={true}
                  basics={basicData}
                  defaultkey={defaultkey}
                  handleChangedata={handleChangedata}
                  setareaManage={setareaManage}
                  action={action}
                  areamange={areamange}
                />
              )}
              {activeStep === 2 && (
                <View {...props} basicData={basicData} action={action} />
              )}
            </div>
            <Snackbar
              message={snackMessage}
              error={isSnackError}
              open={snackOpen}
              close={snackbarClose}
            />
            {/* <CommonForm
          action={action}
          buttons={buttons}
          activeStep={activeStep}
          labelData={labelData}
          data={data}
          headlperText={headlperText}
        /> */}
          </div>
        </div>
      </div>
    </div>
  );
}
